import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { CmsConverterService, defaultLinkData, defaultTextInput } from '../../../../services/cms-converter/cms-converter.service'
import { ConvertedComponentData, Image, LinkData, TextInput } from '../../../types'

@Injectable({ providedIn: 'root' })
export class HeaderSliderHomepageItemConverter extends CmsConverterService<HeaderSliderHomepageItemData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    const title = formData.st_image_title_text?.value
    const altText = formData.st_image_alternative_text?.value
    return {
      headlineTop: formData.st_headline_top ?? defaultTextInput,
      headline: formData.st_headline ?? defaultTextInput,
      highlight: formData.st_cta_highlight?.value?.identifier === 'true',
      image: CmsConverterService.mapImage(formData.st_image_normal, true, altText, title),
      imageMobile: CmsConverterService.mapImage(formData.st_image_mobile, true, altText, title),
      link: formData.st_link ?? defaultLinkData
    }
  }
}

export const HEADER_SLIDER_HOMEPAGE_ITEM_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, HeaderSliderHomepageItemData>>(
  'HeaderSliderHomepageItemConverter')

export interface HeaderSliderHomepageItemData extends ConvertedComponentData {
  headline: TextInput;
  headlineTop: TextInput;
  highlight: boolean;
  image: Image;
  imageMobile: Image;
  link: LinkData;
}
